import { hasYesOrNo } from 'models/validate';
import { ValidateJSModel } from 'forms/shared/types';
import { SubstanceDrugsPrescriptionModel } from './types';
import substanceDrugsPrescriptionItemValidator from './validators/item';

const substanceDrugsPrescriptionValidator: ValidateJSModel<SubstanceDrugsPrescriptionModel> = {
  MisusedDrugs: { presence: true, hasValue: { validator: hasYesOrNo } },
  List: (value, attributes) => {
    if (attributes?.MisusedDrugs && attributes?.MisusedDrugs.value === 'Yes') {
      return {
        presence: true,
        accordion: {
          validator: substanceDrugsPrescriptionItemValidator,
        },
      };
    }
    return {};
  },
  Comments: {},
  SummaryComments: {},
};

export default substanceDrugsPrescriptionValidator;
